import { CreateUserParams } from '../../../../../types/api/endpoints/auth/createUser.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';

const PREFIX = '[registerQuery]';

export const REGISTER_QUERY_KEY = 'REGISTER';

export const RegisterQuery = async ({ variant, user }: CreateUserParams) => {
  console.log(PREFIX, `Fetching form title...`);
  const response = await AUTH_ENDPOINTS.createUser({ variant, user });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  // console.log('----------------------->', json)

  console.log(PREFIX, `Received form title.`);
  return json;
};
